import React, { useLayoutEffect, useRef } from 'react';
import "../../styles/FitText.css";

// Testo che occupa il massimo spazio del contenitore (es. i bottoni grandi del dettaglio ordine):
// il font piu' grande con cui il testo, anche andando a capo, sta nell'area interna del padre.
// Il padre deve essere `position: relative`; il calcolo si ripete a ogni ridimensionamento.
// `fill` = quota dell'area interna che il testo puo' occupare (il resto e' aria verso il bordo).
const FitText = ({ children, min = 12, max = 200, fill = 0.75 }) => {
    const boxRef = useRef(null);
    const textRef = useRef(null);

    useLayoutEffect(() => {
        const box = boxRef.current;
        const text = textRef.current;

        const fit = () => {
            const style = getComputedStyle(box);
            const width = (box.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)) * fill;
            const height = (box.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom)) * fill;
            let lo = min;
            let hi = max;
            while (hi - lo > 0.5) {
                const mid = (lo + hi) / 2;
                box.style.fontSize = mid + 'px';
                if (text.offsetWidth <= width && text.offsetHeight <= height) lo = mid;
                else hi = mid;
            }
            box.style.fontSize = lo + 'px';
        };

        fit();
        // Il box e' in posizione assoluta: cambiare il font non ne cambia la dimensione, niente loop
        const observer = new ResizeObserver(fit);
        observer.observe(box);
        return () => observer.disconnect();
    }, [children, min, max, fill]);

    return (
        <span ref={boxRef} className="fit-text">
            <span ref={textRef}>{children}</span>
        </span>
    );
};

export default FitText;
